import { Injectable } from '@angular/core';

import { lastValueFrom } from 'rxjs';
import { RaInjectOneidAuthTokenService } from '@wdpr/ra-angular-oneid-auth-token-injector';

import { AuthenticationService } from '../authentication/authentication.service';
import { NativeBridgeService } from '../../native-bridge/native-bridge.service';
import { OneIdHybridGuest } from '../interfaces/one-id-hybrid-guest';
import { OneIdService } from '../one-id/one-id.service';
import { RAOneIdInjectorServiceConfig } from '../../interfaces/ra-one-id-injector-service-config';
import { TravelAgentService } from '../../travel-agent/travel-agent.service';

@Injectable({
    providedIn: 'root'
})
export class RaInjectAuthTokenService {
    constructor(
        private authenticationService: AuthenticationService,
        private nativeBridgeService: NativeBridgeService,
        private oneIdService: OneIdService,
        private raInjectOneidAuthTokenService: RaInjectOneidAuthTokenService,
        private travelAgentService: TravelAgentService,
    ) {}

    /**
     * Initialize RA Lib injector which injetcs JWT token to authorization header then verifies
     * if the user is logged in and persist OneID data in service.
     * For travel agent flow does not initialize the RA Injector.
     */
    public async initRaInjector(raServiceConfig?: RAOneIdInjectorServiceConfig) {
        const isLoggedIn = await lastValueFrom(this.authenticationService.isLoggedInOneId());
        let hybridGuest: OneIdHybridGuest;

        // Do not initialize RA Lib injector if travel agent is logged in
        if (this.travelAgentService.isTravelAgentLoggedIn()) {
            return;
        }

        await this.raInjectOneidAuthTokenService.init({
            ENABLED: raServiceConfig?.enabled ?? true,
            NONLOGGEDINFLOW: raServiceConfig?.nonLoggedInFlow ?? true,
            LOGGEDINFLOW: raServiceConfig?.loggedInFlow ?? true
        });

        if (!isLoggedIn) return;

        if (this.nativeBridgeService.isEmbedded(true)) {
            hybridGuest = await this.raInjectOneidAuthTokenService.getOneIdData();
            this.oneIdService.setHybridGuest(hybridGuest);

            return;
        }

        await this.oneIdService.setGuestFromPepObject();
    }
}
